import { useLocation } from 'react-router'

import {
  Sidebar,
  SidebarBody,
  SidebarFooter,
  SidebarHeader,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
} from '@ankor-io/ui-components'

import navItems from './nav-items'

const SidebarComponent = () => {
  const location = useLocation()

  return (
    <Sidebar className="lg:pt-14 lg:border-r border-gray-200 dark:border-gray-600">
      <SidebarHeader>Lighthouse</SidebarHeader>
      <SidebarBody className="p-2 lg:pl-4 lg:pr-2 lg:py-2">
        <SidebarSection>
          {navItems.map((item) => {
            const isActive =
              location.pathname === item.url ||
              (item.url !== '/' && location.pathname.startsWith(item.url)) ||
              (item.url !== '/' && item.alternativeUrls?.some((url) => location.pathname.startsWith(url)))

            return (
              <SidebarItem
                key={item.title}
                to={item.url}
                current={isActive}
                aria-label={item.title}
                disabled={item.disabled}
              >
                <item.icon
                  data-slot="icon"
                  className="size-5 shrink-0"
                />
                <SidebarLabel>{item.title}</SidebarLabel>
              </SidebarItem>
            )
          })}
        </SidebarSection>
      </SidebarBody>

      <SidebarFooter className="p-2 lg:pl-4 lg:pr-2 lg:py-2">
        <SidebarSection>
          <SidebarItem
            type="button"
            // onClick={() => setIsOrganizationsModalOpen(true)}
            aria-label="Current Organization"
          >
            {/* <Building className="size-4 shrink-0" /> */}
            <SidebarLabel>
              <span className="block text-xs uppercase tracking-wider">Organization</span>
              <span
                data-testid="organization-name"
                className="block text-sm text-gray-900 dark:text-white font-bold truncate"
              >
                {/* {activeOrganization?.name || UNNAMED_ORGANIZATION} */}
              </span>
            </SidebarLabel>
          </SidebarItem>
        </SidebarSection>
      </SidebarFooter>
    </Sidebar>
  )
}

export default SidebarComponent
